<template>
  <div class="container themeable">
    <!-- 机构选择遮罩层 -->
    <div style="display: none;" v-show="showModal" class="chooseUserModal">
      <div class="chooseUserDig">
        <div v-if="deployEnvirConfig==1" class="chooseDigTitle">米粒助教提醒您选择机构</div>
        <div :class="orgsClass" class="orgContainer">
          <div v-for="org in orgList" class="org" :key="org.OrgId">
            <img :title="org.OrgName" @click="doLogin(org.OrgId)" class="orgLogo" v-on:error="imgError" :src="combineOrgLogo(org.OrgLogo)" />
            <p :title="org.OrgName" v-text="org.OrgName"></p>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>

    <!-- 忘记密码遮罩层 -->
    <div style="display: none;" v-show="showForget" class="chooseUserModal">
      <div class="chooseUserDig">
        <div class="chooseDigTitle forgetTitle">米粒助教-重设密码
          <span class="closeDig" v-on:click="closeDig">×</span>
        </div>
        <div :class="orgsClass" class="orgContainer forgetinput">
          <img src="../../assets/img/resetcode.jpg" />
          <div>
            <input autocomplete="off" v-model="forgetPhone" placeholder="请输入手机号" />
          </div>
          <div class="getcode">
            <input autocomplete="off" v-model="forgetCode" placeholder="请输入验证码" />
            <button style="cursor: not-allowed;" v-show="counter<61" disabled="disabled" @click="getCode">重新发送
              {{counter}}s</button>
            <button v-show="counter==61" @click="getCode">获取验证码</button>
          </div>
          <div>
            <input autocomplete="off" type="password" v-model="newPwd" placeholder="请输入新密码" />
          </div>
          <div v-show="forgetOrgList.length>1">
            <span>请勾选需要修改密码的机构账户。</span>
            <br />
            <div v-for="org in forgetOrgList" class="orgckb" :key="org.OrgId">
              <input v-model="org.isCheck" type="checkbox" :id="'forgetId'+org.OrgId" :value="org.OrgId" />
              <span :for="'forgetId'+org.OrgId" v-text="org.Name">1</span>
            </div>
          </div>
        </div>
        <div @click="changePwd" class="forgetbtn">
          <button>确定</button>
        </div>
      </div>
    </div>

    <!--logo部分-->
    <!-- <div class="topbar">
      <div class="logo_box">
        <div class="logo">
          <img v-if="deployEnvirConfig==1" title="米粒助教官网" @click="goIndex" src="../../assets/img/logo.png" />
          <img v-if="deployEnvirConfig==2" title="苏州阿芬奇官网" @click="goIndex" src="../../assets/img/aifenqi.png" />
        </div>
      </div>
    </div> -->

    <!--输入框部分-->
    <div class="login_bg_box backgroundImg">

      <div class="login_box">
        <div class="rightloginimg">
          <!-- <img src="../../assets/img/logologin.png" />
          <img v-if="otherlogoimg" class="otherlogo" :src="otherlogoimg" /> -->
          <!-- <div class="logintext">
            米粒助教V1.0成功上线啦!
          </div> -->
          <img src="../../assets/img/loginimg.png" />
          <!-- <div class="loginfunction">
            <ul>
              <li>营销招生</li>
              <li>教务管理</li>
              <li>家校互通</li>
              <li>客户中心</li>
              <li>保险办理</li>
              <li>移动办公</li>
            </ul>
          </div> -->
        </div>
        <div class="login_main">
          <!-- <img src="../../assets/img/crm/customer_unknown.png" style="width: 80px; display: block; margin: 0 auto 20px;" /> -->
          <div style="line-height:100px; font-size:24px; color:#292929;">Hi,欢迎登录</div>
          <div class="username">
            <i class="iconfont icon_shouji"></i>
            <input v-model="userName" placeholder="手机号">
          </div>
          <div class="userpassword">
            <i class="iconfont icon_mima"></i>
            <input v-model="userPwd" type="password" autocomplete="off" name="loginPW" id="loginPW" placeholder="密码">
          </div>
          <div v-text="errorMsg" class="errorMsg"></div>
          <!-- <div class="re_password">
            <span class="fogetPwd" @click="forgetPwd">忘记密码？</span>
          </div> -->
          <button v-text="loginStatus" :disabled="loginBtnDisable" @click="getUserList" class="login_btn">登录</button>
          <!-- <button @click="doRegist" class="login_btn resign_btn">机构注册</button> -->
          <div class="lineInterval passwordLine">
            <div>
              <checkbox-group v-model="rememberPassword">
                <Checkbox :label="true" class="passwordColor">记住密码?</Checkbox>
              </checkbox-group>
            </div>
            <div class="passwordColor" @click="forgetPwd">
              忘记密码
            </div>
          </div>
          <div class="lineInterval contactLine">客服热线：13739171793</div>
        </div>
        <div class="myname">
          <span v-if="deployEnvirConfig==1">
            版权所有：Copyright@苏州九方信息科技有限公司
            <a style="color:#ffffff; text-decoration:underline;" href="http://www.miitbeian.gov.cn">苏ICP备2021024954号-3</a>
          </span>
        </div>
      </div>

    </div>

    <!--页脚部分-->
    <!-- <div class="footer_box">
      <div class="myname">
        <span v-if="deployEnvirConfig==1">
          版权所有：Copyright@XXX科技(苏州)有限公司 客服热线：13739171793
          <a style="color: inherit; text-decoration: none;" href="http://www.miitbeian.gov.cn">苏ICP备16054755号</a>
        </span>
        <span v-if="deployEnvirConfig==2">
          版权所有：Copyright@苏州XXX科技有限公司
        </span>
      </div>
    </div> -->

  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';
  import {
    app
  } from '../../base/config.js'
  export default {
    data() {
      return {
        rememberPassword: [],
        token: '',
        userName: '',
        userPwd: '',
        errorMsg: '',
        loginStatus: '登录',
        loginBtnDisable: false,
        footerWords: '阿拉云信息科技 版权所有 Copyright(c)' + new Date().getFullYear(),
        showModal: false,
        orgsClass: '',
        orgList: [],
        showForget: false,
        forgetPhone: '',
        forgetCode: '',
        newPwd: '',
        counter: 61,
        counterText: '重新发送（60s）',
        forgetOrgList: [],
        deployEnvirConfig: this.staticConfig.deployEnvirConfig,
        otherlogoimg:null,
        sztqdlogo:require("@/assets/img/otherlogo/logo_sztqd.png")
      }
    },
    computed: {
      ...mapGetters({
        hasOrgMenu: "checkHasOrgMenu",
        hasBranchMenu: "checkHasBranchMenu"
      })
    },
    created() {
      this.keyupSubmit();
      this.token = this.$route.query.token;
      if (this.token) {
        this.token = decodeURIComponent(this.token)
        this.getUserInfoForLogin(this.token);
      }
    },
    mounted() {
      this.checkRemberCookie();
      if (this.$route.query && this.$route.query.source) {
        if (this.$route.query.source=="sztqd") {
          this.otherlogoimg=this.sztqdlogo;
        }
      }
    },
    methods: {
      checkRemberCookie() {
        let org_RememberPassword;
        let jsObj;
        if (org_RememberPassword = app.cookieUtil._getCookie('Org_Remember_Password'), org_RememberPassword) {
          if (jsObj = JSON.parse(org_RememberPassword), jsObj instanceof Object) {
            this.rememberPassword=[true];
            let mockPassword = "";
            for (let index = 0; index < jsObj['PasswordLength']; index++) {
              mockPassword += "1";
            }
            this.userName = jsObj['UserName'];
            this.userPwd = mockPassword;
            this.getUserInfoForLogin(jsObj['Token']);
          }
        }
      },
      //监听回车事件
      keyupSubmit() {
        document.onkeydown = e => {
          let _key = window.event.keyCode;
          if (_key === 13) {
            if (this.$route.path == '/login') {
              this.getUserList();
            }
          }
        }
      },
      // 机构登陆
      doLogin: function (orgId) {
        let rememberPassword = this.rememberPassword.length > 0 ? true : false;
        let _self = this;
        _self.apiServer.token._getToken({
          account: this.userName.trim(),
          password: this.userPwd.trim(),
          orgid: orgId,
          remember: rememberPassword
        }).then(res => {
          if(res&&res.code==500){
            this.$Message.error(res.message);
            return;
          }
          if (rememberPassword) {
            //记住密码
            let org_Remember_Password = {
              UserName: this.userName.trim(),
              PasswordLength: this.userPwd.trim().length,
              Token: res
            };
            app.cookieUtil._setCookie('Org_Remember_Password', JSON.stringify(org_Remember_Password), 7);
          } else {
            app.cookieUtil._clearCookie('Org_Remember_Password');
          }
          this.getUserInfoForLogin(res);
          // app.tokenUtil.saveTokenData(res);
          // localStorage.lastLoginDate = new Date();
          // _self.$store.dispatch('getUserInfo', {
          //   type: 'login',
          //   callback: () => {
          //     if (_self.hasOrgMenu) {
          //       this.$router.push('/org');
          //     } else if (_self.hasBranchMenu) {
          //       this.$router.push('/branch');
          //     } else {
          //       this.$Message.error('您没有权限，请联系负责人申请权限');
          //       _self.$store.dispatch("removeUserInfo");
          //       this.loginStatus = "登录";
          //       this.loginBtnDisable = false;
          //     }
          //   }
          // })
        });
      },
      getUserInfoForLogin(token) {
        let _self = this;
        app.tokenUtil.saveTokenData(token);
        localStorage.lastLoginDate = new Date();
        _self.$store.dispatch('getUserInfo', {
          type: 'login',
          callback: () => {
            if (_self.hasOrgMenu) {
              this.$router.push('/org');
            } else if (_self.hasBranchMenu) {
              this.$router.push('/branch');
            } else {
              this.$Message.error('您没有权限，请联系负责人申请权限');
              _self.$store.dispatch("removeUserInfo");
              this.loginStatus = "登录";
              this.loginBtnDisable = false;
            }
          }
        })
      },
      // 点击机构登陆 获取机构列表
      getUserList: function () {
        this.errorMsg = '';
        if (this.userName.trim().length != 11) {
          this.errorMsg = '请输入11位手机号';
          return;
        }
        if (this.userPwd.trim().length < 1) {
          this.errorMsg = '请输入密码';
          return;
        }
        this.loginStatus = "正在登录...";
        this.loginBtnDisable = true;
        // var req = {
        //   phone: this.userName.trim(),
        //   pwd: this.userPwd.trim()
        // }        
        //登录前清除本地token信息
        app.tokenUtil.clearTokenData();
        this.apiServer.token._orgSelect({
          account: this.userName.trim(),
          password: this.userPwd.trim()
        }).then(res => {
            //const data = res.body;
            if (res.code == 500) {

              this.errorMsg = res.message;
              this.loginStatus = "登录";
              this.loginBtnDisable = false;
            } else {
              if (res) {
                // 唯一确定用户 直接登录
                if (res.length == 0) {
                  this.errorMsg = "用户名或密码错误，如有疑问请致电客服";
                  this.loginStatus = "登录";
                  this.loginBtnDisable = false;
                } else if (res.length == 1) {
                  this.doLogin(res[0].OrgId);
                } else {
                  switch (res.length) {
                    case 2:
                      this.orgsClass = 'twoOrg';
                      break;
                    case 3:
                      this.orgsClass = 'threeOrg';
                      break;
                    default:
                      this.orgsClass = '';
                      break;
                  }
                  //选择用户
                  this.orgList = res;
                  this.showModal = true;
                }
              }
            }
          }
          // , res => {
          //   if (res.status == 400) {
          //     this.errorMsg = "请输入正确的手机号和密码，如有疑问请致电0512-68835501";
          //   }
          //   if (res.status == 404) {
          //     this.errorMsg = "用户名或密码错误，如有疑问请致电0512-68835501";
          //   }
          //   this.loginStatus = "机构登录";
          //   this.loginBtnDisable = false;
          // }
        )
      },

      // 注册
      doRegist: function () {
        window.location.href = 'http://www.milijiazhang.com/Login/Login.html';
      },

      // 去官网
      goIndex: function () {
        window.location.href = 'http://www.milijiazhang.com';
      },

      // 图片带机构Logo
      combineOrgLogo: function (logo) {
        return this.staticConfig.addressConfig.fileServerDomain + logo + '?imageView2/1/w/150/';
      },

      // 图片错误事件
      imgError: function (el) {
      },

      // 忘记密码
      forgetPwd: function () {
        // this.showForget = true;
        this.$router.push('/login/forgetPassword');
      },

      // 关闭忘记密码
      closeDig: function () {
        this.showForget = false;
      },

      // 获取手机验证码
      getCode: function () {
        var self = this;
        if (this.forgetPhone.trim().length == 0) {
          this.$Message.info('请输入手机号码');
          return false;
        }
        if (this.forgetPhone.trim().length != 11) {
          this.$Message.info('请输入正确的手机号码')
          return false;
        }

        // 验证码倒计时
        function _subCounter() {
          self.counter -= 1;
          if (self.counter > 0) {
            setTimeout(function () {
              _subCounter();
            }, 1000);
          } else {
            self.counter = 61;
          }
        }
        _subCounter();

        this.$http.get(app.config.baseUrl + '/api/validatecode/mobilevalidatecode/SendMobileValidateCode', {
          params: {
            mobile: this.forgetPhone
          }
        }).then(res => {
          if (res.Code == app.config.ajaxCode.success) {
            this.$Message.info('发送成功，请注意查收');
          } else {
            this.$Message.info(res.message);
          }
        });
      },

      // 重置密码
      changePwd: function () {
        if (this.forgetPhone.trim().length == 0) {
          this.$Message.info('请输入手机号码');
          return false;
        }
        if (this.forgetPhone.trim().length != 11) {
          this.$Message.info('请输入正确的手机号码');
          return false;
        }
        if (this.forgetCode.trim().length != 6) {
          this.$Message.info('请输入6位验证码');
          return false;
        }
        if (this.newPwd.trim().length < 6 || this.newPwd.trim().length > 18) {
          this.$Message.info('请输入6-18新密码');
          return false;
        }
        var orgIdList = [];
        if (this.forgetOrgList.length > 1) {
          this.forgetOrgList.forEach(function (item) {
            if (item.isCheck) {
              orgIdList.push(item.OrgId);
            }
          });
          if (orgIdList.length == 0) {
            this.$Message.info('请勾选需要修改密码的账户');
            return false;
          }
        } else if (this.forgetOrgList.length == 1) {
          orgIdList.push(this.forgetOrgList[0].OrgId);
        } else {
          this.$Message.info('没有找到您手机号码的账户');
          return false;
        }

        this.$http.post(app.config.baseUrl + '/api/Org/OrgUser/ChangePassWordForForgetPassword', {
          phone: this.forgetPhone,
          validateCode: this.forgetCode,
          NewPassword: this.newPwd,
          OrgIdList: orgIdList
        }).then(res => {
          if (res.Code == app.config.ajaxCode.success) {
            this.$Message.info('密码修改成功');
            this.showForget = false;
            this.userName = this.forgetPhone;
          } else {
            this.$Message.info(res.Message);
          }
        });
      },

      // 弹出加载框
      handleSpinShow: function (text, duration) {
        this.$Spin.show({
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                  type: 'load-c',
                  size: 36
                }
              }),
              h('div', text)
            ])
          }
        });
        setTimeout(() => {
          this.$Spin.hide();
        }, duration);
      },

      // 忘记密码时获取机构列表
      getOrgList: function () {
        this.handleSpinShow('账户安全检测中...', 2000);
        this.forgetOrgList = [];
        this.$http.get(app.config.baseUrl + '/api/system/organization/GetUserBelongOrgListByPhone', {
          params: {
            phone: this.forgetPhone
          }
        }).then(res => {
          const data = res.body;
          if (data.Code == app.config.ajaxCode.success) {
            if (data.Data.length == 0) {
              setTimeout(() => {
                this.$Message.info('账户不存在');
              }, 2000);
            } else {
              data.Data.forEach(item => {
                var index = this.forgetOrgList.findIndex(i => i.OrgId == item.OrganizationId); //实际上属于去重  在已有列表中 找不到就push
                if (index == -1) {
                  this.forgetOrgList.push({
                    OrgId: item.OrganizationId,
                    Name: item.Name,
                    isCheck: false
                  });
                }
              });
            }
          } else {
            this.$Message.info(data.Message)
          }
        });
      }
    },

    watch: {
      forgetPhone: function () {
        if (this.forgetPhone.length == 11) {
          this.getOrgList();
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  .container {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #fff !important;
  }

  .loading_background {
    cursor: wait;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0.0;
    filter: alpha(opacity=00);
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000;
  }

  #loading_manage {
    color: #666;
    font-size: 20px;
    position: absolute;
    z-index: 10001;
    left: 0%;
    top: 40%;
    border: 1px solid rgb(187, 187, 187);
    width: auto;
    height: 80px;
    line-height: 78px;
    padding-left: 80px;
    padding-right: 20px;
    background: #fff;
    display: none;
    cursor: pointer;
    border-radius: 8px;
    background-image: url('../../assets/img/loading.gif');
    background-repeat: no-repeat;
    background-position: 8px 50%;
    box-shadow: 0 1px 15px rgba(0, 0, 0, .175);
  }

  .layui-layer-title {
    padding: 0 80px 0 20px;
    height: 40px;
    line-height: 40px;
    border-bottom: none;
    font-size: 14px;
    color: #fff;
    overflow: hidden;
    background-color: #32323B;
    border-radius: 9px 9px 0px 0px;
  }

  .forgetinput .orgckb>input {
    height: 15px;
    width: 20px;
  }

  .orgckb {
    padding: 3px 0;
  }

  .layui-layer {
    border-radius: 9px 9px 0px 0px;
  }

  .layui-layer-content {
    color: white;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1);
  }

  ::-webkit-scrollbar {
    width: 16px;
    height: 16px;
  }

  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb {
    border-radius: 999px;
    border: 5px solid transparent;
  }

  ::-webkit-scrollbar-track {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, .2) inset;
  }

  ::-webkit-scrollbar-thumb {
    min-height: 20px;
    background-clip: content-box;
    box-shadow: 0 0 0 5px rgba(0, 0, 0, .2) inset;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  body {
    padding: 0px;
    margin: 0px;
    font-family: "Microsoft YaHei";
    font-size: 14px;
    color: #444444;
  }

  * {
    font-family: "Microsoft YaHei";
    font-size: 14px;
    color: #444444;
  }

  .logo_box {
    width: 1200px;
    margin: auto;
  }

  .logo_box img {
    display: block;
  }

  .login_main p {
    margin: 0px;
    font-size: 24px;
    color: #5060C9;
    font-weight: normal;
    text-align: center;
    margin-bottom: 30px;
    margin-top: 58px;
  }

  .username,
  .userpassword {
    width: 100%;
    border: 1px solid #d0d0d0;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background: #fff;
    border-radius: 3px;
    text-align: left;
  }

  .username i,
  .userpassword i {
    font-size: 22px;
    margin-left: 7px;
  }
  .errorcheck {
    position: absolute;
    background: #ffe0d9;
    right: 0px;
    padding: 2px 10px;
    color: red;
    border-radius: 3px;
    top: -26px;
  }

  .errorcheck:before {
    content: url("../../assets/img/errorarrow.png");
    position: absolute;
    bottom: -12px;
    left: 10px;
  }

  .username span {
    display: block;
    float: left;
    width: 38px;
    height: 38px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .userpassword span {
    display: block;
    float: left;
    width: 38px;
    height: 38px;
    background-image: url("../../assets/img/userpassword.png");
    background-repeat: no-repeat;
    background-position: center;
  }

  .username input,
  .userpassword input {
    display: block;
    float: right;
    box-sizing: border-box;
    height: 38px;
    padding-left: 8px;
    border: none;
    outline: none;
    width: 90%;
  }

  .login_btn {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    color: #000000;
    line-height: 40px;
    text-align: center;
    border: none;
    margin-top: 10px;
    cursor: pointer;
  }

  .lineInterval {
    margin-top: 20px;
  }

  .service_hotline {
    text-align: left;
    margin-top: 20px;
  }

  .maincolor {
    margin-top: 20px;
    float: left;
    width: 100%;
  }

  .maincolor label {
    display: inline-block;
    height: 4px;
    width: 20px;
    margin: 0 6px;
    border-radius: 3px;
  }

  .copyright {
    width: 100%;
    text-align: center;
    height: 45px;
    line-height: 45px;
    color: #666;
  }

  .myname {
    //background-image: url("../../assets/img/bg_dash_line.png");
    // background-position: center;
    // background-repeat: repeat-x;
    height: 40px;
    text-align: center;
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    opacity: 0.5;
  }

  .myname span {
    line-height: 40px;
    padding: 10px 20px;
    font-size: 14px;
    color: #fff;
  }

  .myname span img {
    vertical-align: top;
    margin-right: 10px;
    margin-top: 6px;
  }

  .topbar {
    height: 80px;
    background: #191919;
  }

  .login_box {
    width: 1120px;
    min-width: 1120px;
    overflow: hidden;
    text-align: center;
    margin: 0 auto;
  }

  .login_main {
    width: 360px;
    height: 400px;
    background: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 30px 30px;
    float: left;
    border-radius: 9px;
  }

  .footer_box {
    width: 1200px;
    margin: auto;
  }

  .leftloginimg img {
    margin-left: 50px;
  }

  // @media (max-width: 1366px) {
  //   // .login_main {
  //   //   margin-top: 60px;
  //   //   width: 360px;
  //   //   height: 360px;
  //   //   padding: 20px 20px;
  //   //   margin-right: 10px;
  //   // }
  //   .footer_box {
  //     width: 1000px;
  //     margin: auto;
  //   }

  //   .logo_box {
  //     width: 1000px;
  //     margin: auto;
  //   }

  //   .leftloginimg img {
  //     width: 490px;
  //     margin-left: 10px;
  //   }

  //   .login_box {
  //     padding: 30px 0px;
  //   }
  // }

  // @media (max-width: 1024px) {
  //   .login_main {
  //     margin-right: 0px;
  //   }

  //   .login_box,
  //   .footer_box {
  //     width: 900px;
  //     margin: auto;
  //   }

  //   .logo_box {
  //     width: 900px;
  //     margin: auto;
  //   }

  //   .leftloginimg img {
  //     width: 420px;
  //     margin-left: 0px;
  //   }

  //   .login_box {
  //     padding: 30px 0px;
  //   }
  // }

  .logo>img {
    padding-top: 10px;
  }

  .chooseUserModal {
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 100;
  }

  .chooseUserDig {
    margin: 180px auto;
    height: 400px;
    width: 500px;
    background-color: white;
    overflow-y: auto;
  }

  .chooseDigTitle {
    text-align: center;
    border-bottom: 1px solid #DDD;
    height: 45px;
    line-height: 45px;
  }

  .orgContainer {
    margin: 10px auto;
    max-width: 400px;
  }

  .orgLogo {
    width: 85px;
    height: 85px;
    margin-left: 4.5px;
    border: 1px solid #ddd;
    cursor: pointer;
  }

  .orgLogo:hover {
    border: 1px solid #00c1de;
  }

  .orgContainer>.org {
    width: 125px;
    text-align: center;
    margin-right: 5px;
    float: left;
  }

  .orgContainer>div>p {
    white-space: nowrap;
    max-width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    margin-left: 3px;
  }

  .clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
  }

  .clearfix {
    zoom: 1;
  }

  .twoOrg {
    padding-left: 92px;
    padding-top: 65px;
  }

  .threeOrg {
    padding-top: 65px;
  }

  .fogetPwd {
    float: right;
    cursor: pointer;
    color: #777;
  }

  .closeDig {
    float: right;
    color: #444;
    position: absolute;
    font-size: 21px;
    cursor: pointer;
    right: 15px;
    top: 9px;
    line-height: 21px;
  }

  .forgetTitle {
    position: relative;
    text-align: left;
    text-indent: 10px;
    font-weight: bold;
  }

  .userpassword {
    margin-bottom: 10px;
  }

  .forgetinput {
    width: 300px;
  }

  .forgetinput>div {
    margin-bottom: 10px;
    overflow: hidden;
  }

  .forgetinput>img {
    margin: auto;
    display: block;
  }

  .forgetinput>div input {
    display: block;
    height: 40px;
    border: 1px solid #d8d8d8;
    width: 100%;
    border-radius: 3px;
    padding: 0px 10px;
    box-sizing: border-box;
    float: left;
    outline: none;
  }

  .forgetinput .getcode input {
    width: 60%;
  }

  .forgetinput .getcode button {
    width: 35%;
    display: block;
    height: 40px;
    border: 1px solid #d8d8d8;
    border-radius: 3px;
    float: right;
    outline: none;
    cursor: pointer;
    background: #eee;
  }

  .forgetbtn button {
    display: block;
    border: none;
    height: 40px;
    line-height: 40px;
    width: 150px;
    margin: auto;
    margin-top: 20px;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    background: #FF5619;
    cursor: pointer;
    outline: none;
  }

  .backgroundImg {
    // background-image: url("../../assets/img/login_bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 96%;
    background-color: #292929;
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: Center;

  }

  .rightloginimg {
    width: 760px;
    height: 400px;
    background-repeat: no-repeat;
    background-position: center;
    float: left;
    text-align: left;
    .otherlogo{
      height: 35px;
      width: 155px;
    }
  }

  .logintext {
    padding: 20px;
    font-size: 24px;
    color: #fff;
    text-align: center;
  }

  .loginfunction {
    padding: 20px 10px 20px 40px;
    overflow: hidden;
  }

  .loginfunction ul li {
    display: block;
    width: 33%;
    float: left;
    color: #fff;
    font-size: 15px;
    line-height: 30px;
  }

  .contactLine {
    color: #999;
    position: relative;
  }

  .contactLine:before {
    left: 0px;
  }

  .contactLine:before,
  .contactLine:after {
    content: '';
    border-top: 1px solid #d8d8d8;
    position: absolute;
    width: 50px;
    top: 10px;
  }

  .contactLine:after {
    right: 0px;
  }

  .passwordLine {
    display: flex;
    justify-content: space-between;
  }

  .passwordColor {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/login/login.vue